import GrComponentFactory from "../../../gr_component_factory";
import GrPropTypes from "../../../shared/gr_prop_types";
import AskTheAuthorInfoContainer from "./ask_the_author_info_container";
import AskTheAuthorFollowedAuthorsStore from "../../../../react_stores/ask_the_author_followed_authors_store";
import AskTheAuthorFollowedAuthorsActions from "../../../../react_actions/ask_the_author/followed_authors_actions";
import CommunityQuestionAnswerContainer from "./community_question_answer_container";
import Reflux from "reflux";

export default GrComponentFactory.createClass({
  mixins: [Reflux.connect(AskTheAuthorFollowedAuthorsStore, "askTheAuthorFollowedAuthorsStore")],

  displayName: "FollowedAuthorsList",

  propTypes: {
    currentUser: GrPropTypes.user().isRequired,
  },

  loadMore(){
    AskTheAuthorFollowedAuthorsActions.loadMoreFollowedAuthors();
  },

  render() {
    const state = this.state.askTheAuthorFollowedAuthorsStore;
    const authors_data = state.authors;
    const remainingAuthors = state.total - state.authors.length;
    let loadMoreButton;
    if (remainingAuthors > 0)
      loadMoreButton = <button className="gr-buttonAsLink askTheAuthorLoadMoreFollowedAuthorsButton"
                               onClick={this.loadMore}> More authors you follow...
                       </button>;
    return (
      <div>
        {
          authors_data.map((author_data) => {
            const commentData = author_data.social.comment;
            const likeData = author_data.social.like;
            const currentUser = this.props.currentUser;
            return (
              <div key={`${author_data.id}-container`}>
                <AskTheAuthorInfoContainer
                  key = {author_data.profileUrl}
                  authorUser = {{ id: author_data.id,
                                  name: author_data.name,
                                  profileImage: author_data.profileImage,
                                  profileUrl: author_data.profileUrl }}
                  answersCount = {author_data.answersCount}
                  answerURL = {author_data.answerURL}
                  questionURL = {author_data.questionURL}
                  authorTagline = {author_data.authorTagline}
                  ATAenabled = {author_data.ATAenabled}
                />

                <CommunityQuestionAnswerContainer
                  authorUser = {{ id: author_data.id,
                                  name: author_data.name,
                                  profileImage: author_data.profileImage,
                                  profileUrl: author_data.profileUrl }}
                  currentUser = {currentUser}
                  communityQuestionText = {author_data.recentQuestionText}
                  communityAnswerText={{
                    html: author_data.recentAnswerTruncatedHtml.html,
                    fullContentText: author_data.recentAnswerTruncatedHtml.answerText,
                    truncated: author_data.recentAnswerTruncatedHtml.truncated,
                  }}
                  questionSpoiler = {author_data.recentQuestionSpoiler}
                  answerSpoiler = {author_data.recentAnswerSpoiler}
                  flagForAbuseUrl = {author_data.flagForAbuseUrl}
                  like={{
                    key: likeData.key,
                    label: likeData.label,
                    isLikeable: likeData.isLikeable,
                  }}
                  comment={{
                    canComment: commentData.canComment,
                    commentable: commentData.commentable,
                    subjectKey: commentData.subjectKey,
                    subject: {
                      type: commentData.subject.type,
                      id: commentData.subject.id,
                    },
                    subjectUrl: commentData.subjectUrl,
                  }}
                />
              <div className="u-topGrayBorder">
                  <div className="u-marginTopTiny" />
                </div>
              </div>
            );
          })
        }
        {
          loadMoreButton
        }
      </div>
    );
  },
});
